"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.function.name.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _imeiRequest = require("@/api/imei-request");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _Export2Excel = require("@/vendor/Export2Excel");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    Pagination: _Pagination.default
  },
  data: function data() {
    return {
      data: [],
      imeiRequestId: null,
      visible: false,
      total: 0,
      listLoading: false,
      query: {
        page: 1,
        limit: 10
      },
      loadingExport: false
    };
  },
  methods: {
    handleExport: function handleExport() {
      var _this = this;
      return (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res, data, header;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.loadingExport = true;
              _context.next = 3;
              return _imeiRequest.imeiRequestApi.findDetail(_this.imeiRequestId, {
                page: 1,
                limit: 0
              });
            case 3:
              res = _context.sent;
              _this.loadingExport = false;
              data = res.data.data.map(function (item) {
                return [item.imei, item.product ? item.product.model.type.name : "", item.product ? item.product.model.name : "", item.imei_request.user.name, item.created_at, item.isReceive ? "YES" : "NO", item.receivedAt, item.product ? item.product.rmaNumber : "", item.product ? item.product.isRefund ? "YES" : "NO" : "", item.status, item.note];
              });
              header = ["Imei", "Device type", "Device model", "Agency request", "Date", "Receive status", "Received at", "RMA number", "Refund", "Status", "Note"];
              (0, _Export2Excel.export_json_to_excel)({
                header: header,
                data: data,
                filename: "Request_imei_list"
              });
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    fetchData: function fetchData() {
      var _this2 = this;
      return (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2.listLoading = true;
              _context2.next = 3;
              return _imeiRequest.imeiRequestApi.findDetail(_this2.imeiRequestId, _this2.query);
            case 3:
              res = _context2.sent;
              _this2.listLoading = false;
              _this2.data = res.data.data;
              _this2.total = res.data.total;
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    handleOpen: function handleOpen(imeiRequestId) {
      this.imeiRequestId = imeiRequestId;
      this.visible = true;
      this.fetchData();
    }
  }
};